import { Banner } from '~/components/Banner'
import Button from '~/components/Button'
import { useWallet } from '~/lib/useWallet'

import styles from './BannerList.pcss'
import { BannerClaim, useClaimRewardTokens } from './BannerClaim'
import { CONFIG } from '~/lib/config'
import { Link } from 'react-router-dom'
import Spinner from '~/components/Spinner'

export function BannerList() {
	const wallet = useWallet()

	const claimableTokens = CONFIG.rewardTokens.map((token) => ({
		address: token.address,
		chainId: token.chainId,
	}))
	const { isFetching, rewards, claim, isClaiming } =
		useClaimRewardTokens(claimableTokens)

	if (isFetching) {
		return <Spinner />
	}

	if (rewards.length > 0) {
		return (
			<BannerClaim
				rewards={rewards}
				onClaimClick={claim}
				isClaiming={isClaiming}
			/>
		)
	}

	if (!wallet.account) {
		return (
			<Banner
				title="Great news for all veSIS holders!"
				hint="https://x.com/symbiosis_fi/status/1851501047455629702"
			>
				<div>$SCR and $TAIKO airdrop is available to claim.</div>
				<div>
					Please connect your wallet to see if you are eligible.
				</div>
				<div>
					<br />
					<Button
						className={styles.goToRewardsButton}
						onClick={() => wallet.connect()}
					>
						Connect wallet
					</Button>
				</div>
			</Banner>
		)
	}

	return (
		<Banner title="Oops!">
			<div>
				Unfortunately, you’re not eligible for additional rewards at
				this time. You can{' '}
				<Link className={styles.link} to="/vesis/zksync/create">
					create a lock
				</Link>{' '}
				and receive rewards in the future.
			</div>
		</Banner>
	)
}
